
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/folder/[folderId]",
      function () {
        return require("private-next-pages/folder/[folderId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/folder/[folderId]"])
      });
    }
  